import dayjs, { Dayjs } from 'dayjs';

export const DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Converts a string representation of a date to a Date object.
 * If no string is provided, the current date is returned.
 *
 * @param dateToConvert - The string to be converted into a Date object.
 * @returns A Date object representing the given date string, or the current date if no string is provided.
 * @throws An error if the provided date string is invalid.
 */
export function stringToDate(dateToConvert?: string): Date {
  if (dateToConvert) {
    if (dayjs(dateToConvert).isValid()) {
      return dayjs(dateToConvert).toDate();
    } else {
      throw new Error(`Invalid date: ${dateToConvert}`);
    }
  }
  return new Date();
}

/**
 * Converts a given Date object to a string formatted as 'YYYY-MM-DD'.
 * If no date is provided, returns the current date in the same format.
 *
 * @param dateToConvert - The Date object to convert. Optional.
 * @returns The formatted date string.
 */
export function dateToString(dateToConvert?: Date): string {
  if (dateToConvert) {
    return dayjs(dateToConvert).format(DATE_FORMAT);
  }
  return dayjs().format(DATE_FORMAT);
}

/**
 * Converts a Dayjs date object to a string formatted as 'YYYY-MM-DD'.
 * If no date is provided, returns the current date in the same format.
 *
 * @param dateToConvert - An optional Dayjs date object to be converted.
 * @returns The formatted date string.
 */
export function dayjsToString(dateToConvert?: Dayjs): string {
  if (dateToConvert) {
    return dateToConvert.format(DATE_FORMAT);
  }
  return dayjs().format(DATE_FORMAT);
}
